
import {defineComponent} from 'vue'
import CardContentSeparator from "./CardContentSeparator.vue";

export default defineComponent({
    name: "SkeletonInternetAndMobileCard",
    components: {CardContentSeparator}
})
